import api from './api';

// ── Types ─────────────────────────────────────────────────────────────────────

export type HealthSeverity = 'error' | 'warning' | 'info';

export interface HealthCheck {
  count:    number;
  severity: HealthSeverity;
  label:    string;
}

export interface HealthChecks {
  orphanedBalances:   HealthCheck;
  staleSupplierLinks: HealthCheck;
  stockNoSupplier:    HealthCheck;
  missingBalances:    HealthCheck;
  unusedItems:        HealthCheck;
  emptyWineLists:     HealthCheck;
}

export interface HealthSummaryResponse {
  checks:      HealthChecks;
  generatedAt: string;
}

// ── Service ───────────────────────────────────────────────────────────────────

const healthService = {
  getSummary: async (): Promise<HealthSummaryResponse> => {
    const res = await api.get<HealthSummaryResponse>('/admin/governance/health');
    return res.data;
  },
};

export default healthService;
